export const getPageTag = (pathname: string, buttonLabel: string) => {
  return (
    (pathname === '/'
      ? 'homepage'
      : pathname.substring(1, location.pathname.length)) +
    '-' +
    buttonLabel
  );
};
